module.exports = __webpack_public_path__ + "assets/de3fd36b28792c546161957e70cb7aba.mp3";